import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";

const useHome = () => {
    const navigate = useNavigate();
    const handleMessage =()=>{
        const Toast = Swal.mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
            didOpen: (toast) => {
                toast.onmouseenter = Swal.stopTimer;
                toast.onmouseleave = Swal.resumeTimer;
                }
            });
            Toast.fire({
                icon: "warning",
                title: "Pagina en Construcción!!!"
            });           
    }
     const handleNavigation = (path: string) => {
        navigate(path);
    };

    return {
        handleMessage,
        handleNavigation,
    }
}
export default useHome